<template>
    <v-dialog v-model="dialog" max-width="700">
        <v-card>
            <v-card-title class="primary white--text title">
                Chiller Optimisation Example
            </v-card-title>
            <v-card-text>
                Using PSO optimisation algorithm, expected COP under different operating parameters at particular cooling loads can be found as
                depicted by the red dots.  The historical consumption is shown as blue dots below.  By choosing optimal
                temperature setpoints and sequencing, energy saving can be achieved by picking the set of parameters achieving
                highest COP.
            </v-card-text>
            <v-card-text>
                <v-spacer></v-spacer>
                <v-img :src="require('@/assets/img/Cooling_Load_vs_COP.png')" max-width="600">
                </v-img>
                <v-spacer></v-spacer>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'CoolingLoadExplanation',
    props: {
      value: {type: Boolean, default: false}
    },
    data () {
      return {
        dialog: false
      }
    },
    watch: {
      value () {
        if (this.dialog != this.value){
          this.dialog = this.value
        }
      }
    },
    methods: {
      openDialog() {
        this.dialog = true
      }
    }

  }
</script>

<style scoped>

</style>
